$(document).ready(function(){

	// footer
	$("#freshwater-footer h3").click(function () {
		$(this).next().toggle();
		$(this).find("span").toggleClass('rotate-45');
	});

	// video popup 1
	$(".index-quote-image-1 a, .index-quote-image-1 img").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup-1").show();
	});
	$(".freshwater-video-popup-close").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup-1").hide();
		$(".freshwater-video-popup-1 iframe").each(function(index) {
	        // $(this).attr('src', $(this).attr('src'));
	        // return false;
            var src = $(this).attr('src');
            $(this).attr('src', ''); // Temporarily set src to empty
            $(this).attr('src', src); // Reset src to original URL
	      });
	});
  
	// video popup 2
	$(".index-quote-image-2 a, .index-quote-image-2 img").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup-2").show();
	});
	$(".freshwater-video-popup-close").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup-2").hide();
		$(".freshwater-video-popup-2 iframe").each(function(index) {
	        // $(this).attr('src', $(this).attr('src'));
	        // return false;
            var src = $(this).attr('src');
            $(this).attr('src', ''); // Temporarily set src to empty
            $(this).attr('src', src); // Reset src to original URL
	      });
	});

	// video popup 3
	$(".index-quote-image-3 a, .index-quote-image-3 img").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup-3").show();
	});
	$(".freshwater-video-popup-close").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup-3").hide();
		$(".freshwater-video-popup-3 iframe").each(function(index) {
	        // $(this).attr('src', $(this).attr('src'));
	        // return false;
            var src = $(this).attr('src');
            $(this).attr('src', ''); // Temporarily set src to empty
            $(this).attr('src', src); // Reset src to original URL
	      });
	});
  
	// mainpage video popup
	$(".image-launch-video").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup").show();
	});
	$(".image-launch-video1").click(function () {
		$(".freshwater-video-popup-background1, .freshwater-video-popup1").show();
	});
	$(".image-launch-video2").click(function () {
		$(".freshwater-video-popup-background2, .freshwater-video-popup2").show();
	});
	$(".image-launch-video3").click(function () {
		$(".freshwater-video-popup-background3, .freshwater-video-popup3").show();
	});  
	$(".image-launch-video4").click(function () {
		$(".freshwater-video-popup-background4, .freshwater-video-popup4").show();
	});  
	$(".image-launch-video5").click(function () {
		$(".freshwater-video-popup-background5, .freshwater-video-popup5").show();
	});    
	$(".image-launch-video6").click(function () {
		$(".freshwater-video-popup-background6, .freshwater-video-popup6").show();
	});      
	$(".image-launch-video7").click(function () {
		$(".freshwater-video-popup-background7, .freshwater-video-popup7").show();
	});        
	$(".image-launch-video8").click(function () {
		$(".freshwater-video-popup-background8, .freshwater-video-popup8").show();
	});        
	$(".image-launch-video9").click(function () {
		$(".freshwater-video-popup-background9, .freshwater-video-popup9").show();
	});        
	$(".image-launch-video10").click(function () {
		$(".freshwater-video-popup-background10, .freshwater-video-popup10").show();
	});          
	$(".freshwater-video-popup-close").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup").hide();
		$(".freshwater-video-popup iframe").each(function(index) {
	        // $(this).attr('src', $(this).attr('src'));
	        // return false;
              var src = $(this).attr('src');
              $(this).attr('src', ''); // Temporarily set src to empty
              $(this).attr('src', src); // Reset src to original URL          
	      });
	});		


	//store locator
	$("<p class='store-locator-subhead'>Nixon Power Services has an extensive dealer network for our Kohler Residential and Marine Generator product lines throughout our served territory.</p>").insertAfter("#col-main h2#store-locator-title");
	
	//check if on mainpage, there are any block sections
	if ($(".block-image-section")[0]){

	} else {
	    $("#fresh-main .block-image-section-wrapper").addClass("empty");
	}


	//blog post download
	if ($(".show-download-link .pdf-download-wrapper").length > 0) {
	} else {
		$(".show-download-link").hide();
	}



});

